import React, { Suspense } from 'react'

import { Route, Switch } from 'react-router-dom'

import { LayoutSplashScreen } from '_metronic'

import { TURNOS_LISTA, TURNOS_ABRIR, TURNOS_CERRAR, TURNOS_CAMBIARISLA } from 'constants/codigosTransacciones'

import AbrirPage from './abrirTurno'
import CerrarPage from './cerrarTurno'
import CambiarIslaPage from './cambiarIsla'
import ListaPage from './lista'

export default function TurnosPages() {
  return (
    <Suspense fallback={<LayoutSplashScreen />}>
      <Switch>
        <Route path={`/${TURNOS_LISTA}`} component={ListaPage} />
        <Route path={`/${TURNOS_ABRIR}`} component={AbrirPage} />
        <Route path={`/${TURNOS_CERRAR}`} component={CerrarPage} />
        <Route path={`/${TURNOS_CAMBIARISLA}`} component={CambiarIslaPage} />
      </Switch>
    </Suspense>
  )
}
